namespace Reviews {

    class ReviewHotel {

        public canLeaveReview :boolean = false;
        public loading :boolean = true;
        public previewDisplay :boolean = false;
        public reviewAlreadyLeft :boolean = false;
        public reviewDetails :ReviewDetails;
        public tagLists :{ hotel :string[], location :string[]};
        public userInput :ReviewData = new ReviewData();

        private bookingId :number;
        private token :string;
        private userId :string;

        constructor(
            protected $location: ng.ILocationService,
            protected $q: ng.IQService,
            protected $routeParams: ng.route.IRouteParamsService,
            protected $window: ng.IWindowService,
            protected analytics: any,
            protected dashboardService: any,
            protected reviewPreviewStoreService :ReviewPreviewStoreService,
            protected reviewsService :ReviewsService
        ) {

            //there should only be two possible ways of getting here:
            //1. we are signed in and have selected to leave a review for a previous stay
            //2. we have received an email link
            this.bookingId = $routeParams.bookingId;
            if ($routeParams.bookingId && $routeParams.userId && $routeParams.token) {
                //2. we need to have a booking id, user id and token from the email
                this.userId = $routeParams.userId;
                this.token = $routeParams.token;

                this.reviewsService.getReviewDetailsUsingToken(this.bookingId, this.token, this.userId)
                    .then(d => this.setReviewDetails(d))
                    .finally(() => this.loading = false);
            } else {
                //1. already signed in
                this.reviewsService.getReviewDetails(this.bookingId)
                    .then(d => this.setReviewDetails(d))
                    .finally(() => this.loading = false);
            }

        }


        private setReviewDetails(reviewDetails :ReviewDetails) :ng.IPromise<any> {

            //do some checks to make sure the review hasn't already been submitted / they can leave a review
            let status = reviewDetails.reviewStatus;

            if (status === ReviewStatus.CanLeaveReview) {
                return this.reviewsService.getPredefinedTags().then(tagLists => {
                    this.tagLists = tagLists;
                    this.reviewDetails = reviewDetails;
                    this.canLeaveReview = true;

                    //if we are on mobile we may have returned to this page after previewing the review
                    //so check if we have data and use that
                    let savedData = this.reviewPreviewStoreService.getUserInput();
                    if (savedData) {
                        this.userInput = savedData;
                    }

                    return;
                });


            } else if (status === ReviewStatus.HasLeftReview) {
                this.reviewAlreadyLeft = true;
            }

            return this.$q.when();
        }

        public trackEvent(name, data) {
            this.analytics.track('mixpanel', name, data);
        }

        /**
         * NOTE: we need slightly different functionality for mobile and desktop when displaying the preview
         * and submitting the review. So have created methods named as such to avoid ambiguity
        **/

        //DESKTOP only methods
        public desktopPreviewClose() {
            this.previewDisplay = false;
        }

        public desktopPreviewReview(form) {
            if (!form.$valid) {
                return;
            }

            this.previewDisplay = true;
        }

        public desktopSubmitReview() {
            this.reviewsService.submitReview(this.userInput, this.bookingId, this.token).then(() => {
                //not keen on this event name, but to keep reporting comparable we have used it
                this.analytics.track('mixpanel',
                    'MYB - Review submitted',
                    this.userInput.getRatingData());
                this.$location.path(`/review-hotel/submitted/${this.reviewDetails.hotelDetails.id}`);
            });
        }

        //MOBILE only methods
        public mobilePreviewReview(form) {
            if (!form.$valid) {
                return;
            }
            this.reviewPreviewStoreService.storeReviewInfo(this.reviewDetails, this.userInput);
            this.$location.path(`/review-hotel/preview/${this.bookingId}/${this.userId}/${this.token}`);
        }

    }

    angular
        .module('reviews')
        .controller('ReviewHotel', ReviewHotel);

}
